import React from "react";
import {GenericInput} from "../GenericInput";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  containerClassName?: string;
  inputClassName?: string;
}

export const TableSearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = "Search",
  containerClassName = "grid gap-6 md:grid-cols-4",
  inputClassName = "",
}) => {
  return (
    <div className={containerClassName}>
      <GenericInput
        label=""
        type="text"
        containerClassName={inputClassName}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={false}
      />
    </div>
  );
};
